import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, listShape, recommendationShape } from '@bibliocommons/bc-prop-types';
import Divider from '@bibliocommons/divider';
import HeaderBar from 'app/components/bibs/shared/HeaderBar';
import About from './About';
import Community from './Community';
import Discover from './Discover';
import Explore from './Explore';
import Movies from './Movies';
import Opinion from './Opinion';
import Transact from './Transact';

import './BibPage.scss';

export class BibPage extends React.PureComponent {
  render() {
    const {
      catalogBib,
      staffLists,
      recommendations,
      relatedTitles,
      tags,
      authorSuggestions,
      relatedAuthors,
      onlineResources
    } = this.props;

    const divider = (
      <div className="container">
        <Divider />
      </div>
    );

    return (
      <div className="cp-bib-page" data-key="bib-page">
        <div className="container">
          <HeaderBar />
        </div>
        <Transact catalogBib={catalogBib} />
        {divider}
        <Movies catalogBib={catalogBib} />
        <About catalogBib={catalogBib} />
        {divider}
        <Opinion catalogBib={catalogBib} />
        <Discover catalogBib={catalogBib} staffLists={staffLists} recommendations={recommendations} />
        <Explore
          catalogBib={catalogBib}
          tags={tags}
          relatedTitles={relatedTitles}
          authorSuggestions={authorSuggestions}
          relatedAuthors={relatedAuthors}
          onlineResources={onlineResources}
        />
        <Community catalogBib={catalogBib} />
      </div>
    );
  }
}

BibPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,

  // Props below are used to conditionally render section titles and dividers
  staffLists: ImmutablePropTypes.listOf(listShape).isRequired,
  recommendations: ImmutablePropTypes.listOf(recommendationShape).isRequired,
  relatedTitles: ImmutablePropTypes.listOf(catalogBibShape).isRequired,
  tags: ImmutablePropTypes.list.isRequired,
  authorSuggestions: ImmutablePropTypes.list.isRequired,
  relatedAuthors: ImmutablePropTypes.list.isRequired,
  onlineResources: ImmutablePropTypes.list.isRequired
};

export default BibPage;
